<template>
  <div id="admin-banner" v-if="isAdmin && !adminBannerHidden" class="admin-banner">
    <BaseBadge color="var(--color-primary-dark)" :label="environment" />
    <div class="admin-banner-content">
      <div class="d-flex align-items-center gap-2">
        <span class="d-none d-lg-block"> Viewing as </span>
        <BaseSelectInput
          v-if="isSuperAdmin"
          searchable
          :options="userOptions"
          v-model="selectedUserId"
          @search="loadUsers"
          @input="impersonateUser"
          style="width: 300px;"
        />
        <span v-else> {{ user.email }} </span>
      </div>
      <button class="admin-banner-button" @click="goToDashboard" aria-label="Go to Dashboard">
        Admin
      </button>
      <button class="close-button" @click="hideBanner" v-clicky aria-label="Close admin banner">
        <CloseIcon />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CloseIcon from "../icons/CloseIcon.vue";
import BaseBadge from "./BaseBadge.vue";
import BaseSelectInput from "./BaseSelectInput.vue";

export default {
  name: "AdminBanner",
  components: {
    CloseIcon,
    BaseBadge,
    BaseSelectInput,
  },
  data() {
    return {
      selectedUserId: null,
      userOptions: [],
    };
  },
  computed: {
    ...mapGetters("sessions", [
      "users",
      "user",
      "trueUser",
      "isAdmin",
      "isImpersonating",
    ]),
    ...mapGetters(["adminBannerHidden"]),
    environment() {
      return process.env.STAGING == "true" ? "staging" : process.env.NODE_ENV;
    },
    isSuperAdmin() {
      return (
        this.trueUser &&
        (this.trueUser.role === "super_admin" ||
          this.trueUser.role_type === "super_admin")
      );
    },
    defaultUserOptions() {
      const options = [{ label: this.user.email, value: this.user.id }];
      if (this.trueUser?.id !== this.user?.id) {
        options.push({ label: this.trueUser?.email, value: this.trueUser?.id });
      }
      return options;
    },
  },
  methods: {
    loadUsers(query) {
      // console.log(query);
      if (query.length > 2) {
        this.$store.dispatch("sessions/loadUsers", { query }).then(() => {
          this.userOptions = this.users.map((user) => ({
            label: user.email,
            value: user.id,
          }));
        });
      } else {
        this.userOptions = this.defaultUserOptions;
      }
    },
    impersonateUser() {
      this.$store
        .dispatch("sessions/impersonateUser", this.selectedUserId)
        .then(() => {
          window.location.href = "/";
        });
    },
    goToDashboard() {
      window.location.href = "/admin";
    },
    hideBanner() {
      this.$store.dispatch("setAdminBannerHidden", true);
    },
  },
  mounted() {
    this.selectedUserId = this.user?.id;
    this.userOptions = this.defaultUserOptions;
  },
};
</script>

<style scoped lang="scss">
.admin-banner {
  white-space: nowrap;
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--color-warning);
  padding: 10px 40px;
  display: flex;
  gap: 20px;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  box-shadow: 0 2px 4px var(--color-shadow-light);
  z-index: 15;
  min-height: 60px;
}
.admin-banner-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.7;
    text-decoration: underline;
  }
}
@media (max-width: 991px) {
  .admin-banner {
    padding: 10px 20px;
    gap: 10px;
  }
}

.admin-message {
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.admin-banner-content {
  display: flex;
  gap: 10px;
  align-items: center;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 20px;
    height: 20px;
  }
}
</style>
